import { NavRoute } from '@/types';

export const AppRoutes = {
  HOME: '/',
  FACE_ID_PROFILES: '/face-id-profiles',
  FACE_ID_PROFILE_CREATION: '/face-id-profiles/create',
  FACE_ID_PROFILE_UPDATE: '/face-id-profiles/:id/edit',
  FACE_ID_PROFILE_DETAILS: '/face-id-profiles/:id',
  IPAD_CONFIGURATIONS: '/ipad-configurations',
  IPAD_CONFIGURATION_CREATION: '/ipad-configurations/create',
  IPAD_CONFIGURATION_UPDATE: '/ipad-configurations/:id/edit',
  IPAD_CONFIGURATION_DETAILS: '/ipad-configurations/:id',
  CHECK_IN_LOGS: '/check-in-logs',
  CHECK_IN_LOG_DETAILS: '/check-in-logs/:id',
  ROLE_ASSIGNMENTS: '/roles/assignments',
  ROLE_ASSIGNMENT_CREATION: '/roles/assignments/assign',
  ROLE_ASSIGNMENT_UPDATE: '/roles/assignments/:id/edit',
  ROLE_ASSIGNMENT_DETAILS: '/roles/assignments/:id',
  LOGIN_PAGE: '/login',
  FORBIDDEN: '/403',
  INTERNAL_SERVER_ERROR: '/500',
  NOT_FOUND: '/404',
};

export const ROUTE_LABELS: Record<NavRoute, string> = {
  [AppRoutes.HOME]: 'Face Profile ID',
  [AppRoutes.FACE_ID_PROFILES]: 'Face Profile ID',
  [AppRoutes.FACE_ID_PROFILE_CREATION]: 'Create New Profile',
  [AppRoutes.FACE_ID_PROFILE_UPDATE]: 'Edit Profile',
  [AppRoutes.IPAD_CONFIGURATIONS]: 'iPad Configurations',
  [AppRoutes.IPAD_CONFIGURATION_CREATION]: 'Create New Configuration',
  [AppRoutes.IPAD_CONFIGURATION_UPDATE]: 'Edit Configuration',
  [AppRoutes.CHECK_IN_LOGS]: 'Check-in Logs',
  [AppRoutes.ROLE_ASSIGNMENTS]: 'Role Assignment',
  [AppRoutes.LOGIN_PAGE]: 'Login',
  [AppRoutes.ROLE_ASSIGNMENT_CREATION]: 'Assign Role',
  [AppRoutes.ROLE_ASSIGNMENT_UPDATE]: 'Edit Role',
  [AppRoutes.LOGIN_PAGE]: 'Login',
};

export const ERROR_ROUTES = [
  AppRoutes.FORBIDDEN,
  AppRoutes.INTERNAL_SERVER_ERROR,
  AppRoutes.NOT_FOUND,
];
